// src/components/groups/InvitationEmailAction.jsx
// The invitation email's two links, no sign-in (Roadmap #54, Invitations Build 2 §4, Phase 3):
//   #/invitation-optout/<token> — stop all invitation emails to this address, from any group;
//   #/invitation-report/<token> — report this invitation against the group that sent it.
// NOTHING is called when the page opens: mail scanners open every link in a message, so the
// database is reached only on a button press (ledger, Phase 1 A10). Both work after the invitation
// has expired or its group has gone. The address is never shown.

import React, { useState } from 'react';
import { useTranslation } from '../../i18n/useTranslation';
import { groupService } from '../../data/dataService';
import StandardButton from '../core/StandardButton';
import InvitationPageShell, { InvitationActions, InvitationText } from './InvitationPageShell';
import { goHome } from './InvitationOutcome';

const InvitationEmailAction = ({ mode, token }) => {
  const { t } = useTranslation('groups');
  const [working, setWorking] = useState(false);
  // 'done' | 'invalid' | 'failed'. A cut-off or mangled link arrives with no token: invalid at once.
  const [answer, setAnswer] = useState(token ? null : 'invalid');

  const isReport = mode === 'report';

  const handlePress = async () => {
    setWorking(true);
    const res = isReport
      ? await groupService.reportInvitation(token)
      : await groupService.unsubscribeInvitationEmail(token);
    setWorking(false);
    setAnswer(res.ok ? 'done' : res.error ? 'failed' : 'invalid');
  };

  if (answer) {
    const line = answer === 'done'
      ? t(isReport ? 'report_page_done' : 'optout_page_done')
      : t(answer === 'invalid' ? 'join_reason_not_found' : 'join_reason_failed');
    return (
      <InvitationPageShell status={answer === 'done' ? 'success' : 'error'} title={t(isReport ? 'report_page_title' : 'optout_page_title')}>
        <InvitationText>{line}</InvitationText>
        <InvitationActions>
          {answer === 'failed' && (
            <StandardButton variant="action" iconName="RefreshCw" label={t('email_action_try_again')} onClick={handlePress} disabled={working} />
          )}
          <StandardButton variant="ghost" iconName="Home" label={t('join_go_home')} onClick={goHome} />
        </InvitationActions>
      </InvitationPageShell>
    );
  }

  return (
    <InvitationPageShell title={t(isReport ? 'report_page_title' : 'optout_page_title')}>
      <InvitationText>{t(isReport ? 'report_page_body' : 'optout_page_body')}</InvitationText>
      <InvitationActions>
        <StandardButton
          variant="action"
          iconName={isReport ? 'Flag' : 'Ban'}
          label={working ? t('email_action_working') : t(isReport ? 'report_page_button' : 'optout_page_button')}
          onClick={handlePress}
          disabled={working}
        />
        <StandardButton variant="ghost" label={t('join_not_now')} onClick={goHome} />
      </InvitationActions>
    </InvitationPageShell>
  );
};

export default InvitationEmailAction;
